import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { TermsService } from '../services/terms.service';

@Injectable({
  providedIn: 'root'
})
export class TermsGuard implements CanActivate, CanActivateChild {

  constructor(private termsService: TermsService) {}
  
  canActivate(): boolean {
    return this.termsService.hasAccepted;
  }

  canActivateChild(): boolean {
    return this.termsService.hasAccepted;

  }
}
